export const GUIDES = [
  { id: "jixxeo", name: "Any smart TV with a web browser", tag: "Works with Jixxeo", steps: [
    "On the TV, open its web browser (Samsung Internet, LG Web Browser, Silk on Fire TV, Chrome on Google TV…).",
    "Go to YOUR-SITE/mirror/tv — a 6-digit code appears.",
    "On your phone or laptop open Jixxeo Mirroring → Cast, enter the code and pick your screen, a photo or a video.",
    "Same Wi-Fi network gives the smoothest picture. Some office/hotel networks block peer connections.",
  ] },
  { id: "chromecast", name: "Chromecast / Google TV", tag: "Cast", steps: [
    "Make sure your phone/computer and the Chromecast are on the same Wi-Fi.",
    "Computer (Chrome or Edge): menu ⋮ → Cast, save and share → Cast… → choose your TV. Under Sources pick Cast tab or Cast screen.",
    "Android phone: open the Google Home app → select your device → Cast my screen. Or pull down Quick Settings → Screen Cast.",
    "Jixxeo shortcut: in Chrome, the “Open on Chromecast” button launches the Jixxeo TV page on your Chromecast automatically.",
  ] },
  { id: "airplay", name: "AirPlay (Apple TV & AirPlay 2 TVs)", tag: "AirPlay", steps: [
    "Connect your iPhone, iPad or Mac to the same Wi-Fi as the Apple TV or AirPlay 2 TV (many Samsung, LG, Sony, Vizio models).",
    "iPhone/iPad: open Control Center → Screen Mirroring → choose your TV. Enter the code if one appears.",
    "Mac: click Control Center in the menu bar → Screen Mirroring → choose your TV.",
    "Videos in Jixxeo Mirroring on Safari show an AirPlay button that sends just the video.",
  ] },
  { id: "miracast", name: "Miracast (Windows & many Android phones)", tag: "Miracast", steps: [
    "Miracast is built into the operating system — browsers can't start it, so use these steps.",
    "Turn on screen mirroring / “Screen Share” on the TV (often under Input or Network settings).",
    "Windows 10/11: press Windows key + K → choose your TV. Use Win + P to switch Duplicate / Extend.",
    "Android: Quick Settings → Smart View / Screen Cast / Wireless display (name varies by brand) → choose the TV.",
  ] },
  { id: "samsung", name: "Samsung Smart TV", tag: "Smart View", steps: [
    "Galaxy phone: swipe down twice → Smart View → choose your Samsung TV → Start now.",
    "iPhone: newer Samsung TVs support AirPlay 2 → Control Center → Screen Mirroring.",
    "Or open the TV's Internet app and go to YOUR-SITE/mirror/tv to use Jixxeo pairing.",
  ] },
  { id: "lg", name: "LG Smart TV (webOS)", tag: "Screen Share", steps: [
    "Open the Screen Share app on the TV (or it starts automatically when a phone connects).",
    "Android: Quick Settings → Screen Cast / Smart View → choose the LG TV. iPhone: 2018+ LG TVs support AirPlay 2.",
    "Or open the TV's Web Browser and go to YOUR-SITE/mirror/tv.",
  ] },
  { id: "firetv", name: "Amazon Fire TV", tag: "Display Mirroring", steps: [
    "Hold the Home button on the remote → Mirroring. The TV waits for a device.",
    "Android/Windows: start Miracast (see above) and pick the Fire TV.",
    "Or open the Silk Browser on the Fire TV and go to YOUR-SITE/mirror/tv.",
  ] },
  { id: "roku", name: "Roku", tag: "Screen Mirroring", steps: [
    "Roku: Settings → System → Screen mirroring → set mode to Prompt or Always allow.",
    "Android/Windows: start Miracast (see above) and choose the Roku. iPhone/Mac: many Rokus support AirPlay → Control Center → Screen Mirroring.",
    "Roku has no full web browser, so the Jixxeo TV page isn't available on Roku.",
  ] },
];
